export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const AUTH_STORAGE_KEY = "g-profile";
export const INPUT_FIELD_MAX_LENGTH = 35;
export const COMPANY_NAME_MAX_LENGTH = 50;
export const COMPANY_LABEL_MAX_LENGTH = 10;
export const DECIMAL_NUMBERS = /^\d{1,8}(\.\d{1,2})?$/;
export const PRICE_FIELD_MAX_LENGTH = 11;

export const WIDTH_STICKER_FOR_PRINT = "1.97in";
export const HEIGHT_STICKER_FOR_PRINT = "0.98in";

export const ADMIN_WORKSPACE_URL = process.env.REACT_APP_ADMIN_WORKSPACE_URL;